import axios from 'axios';
import { storageManager } from '../utils/storageManager';

const getVersionFromScriptAndLink = () => {
    const scriptTag = document.querySelector('script[src*="v="]');
    const linkTag = document.querySelector('link[href*="v="]');

    let version = null;

    if (scriptTag) {
        const src = new URL(scriptTag.src);
        version = src.searchParams.get('v');
    }

    if (!version && linkTag) {
        const href = new URL(linkTag.href);
        version = href.searchParams.get('v');
    }

    return version;
};

const api = axios.create({
    baseURL: window.location.origin === 'http://localhost:3000' ? 'http://localhost:5500' : window.location.origin,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use((config) => {
    const version = getVersionFromScriptAndLink();
    const authToken = storageManager.getToken();

    if (version) {
        config.headers['app-version'] = version;
    }

    if (authToken) {
        config.headers['Authorization'] = `Bearer ${authToken}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;